/* eslint-disable no-underscore-dangle */ function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { useEffect } from "react";
import whenPropertyIsSet from "../utils/whenPropertyIsSet";
import { subscribe } from "../utils/pubsub";
import { version } from "../config";
var DEFAULT_SATELLITE_TRACKING_IDENT = "target-A4L";
var isAfterPageView = false;
var trackingListenersAttached = false;
/**
 * @deprecated
 */ export function getSatelliteScript() {
    return _getSatelliteScript.apply(this, arguments);
}
function _getSatelliteScript() {
    _getSatelliteScript = _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        whenPropertyIsSet(window, "_satellite", 2000)
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        whenPropertyIsSet(window._satellite, "track")
                    ];
                case 2:
                    _state.sent();
                    return [
                        2,
                        window._satellite
                    ];
            }
        });
    });
    return _getSatelliteScript.apply(this, arguments);
}
/**
 * @deprecated
 */ export function trackRenderedMbox(_) {
    return _trackRenderedMbox.apply(this, arguments);
}
function _trackRenderedMbox() {
    _trackRenderedMbox = _async_to_generator(function(param) {
        var evar, value, _param_satelliteTrackingIdent, satelliteTrackingIdent, track, _obj, error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    evar = param.evar, value = param.value, _param_satelliteTrackingIdent = param.satelliteTrackingIdent, satelliteTrackingIdent = _param_satelliteTrackingIdent === void 0 ? DEFAULT_SATELLITE_TRACKING_IDENT : _param_satelliteTrackingIdent;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        getSatelliteScript()
                    ];
                case 2:
                    track = _state.sent().track;
                    if (trackingListenersAttached === false && typeof window !== "undefined") {
                        window.addEventListener("after-page-view", function() {
                            isAfterPageView = true;
                        });
                        subscribe("pageView", function() {
                            isAfterPageView = false;
                        });
                        trackingListenersAttached = true;
                    }
                    track(satelliteTrackingIdent, (_obj = {}, _define_property(_obj, evar, value), _define_property(_obj, "deferred", isAfterPageView), _obj));
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    console.error("Lapel(v" + version + ") satellite track mbox failed", error.message);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _trackRenderedMbox.apply(this, arguments);
}
/**
 * @deprecated
 */ export function useSatelliteTrack(trackingInfo) {
    var evar = trackingInfo.evar, value = trackingInfo.value;
    useEffect(function() {
        if (evar && value) {
            trackRenderedMbox({
                evar: evar,
                value: value
            });
        }
    }, [
        evar,
        value
    ]);
}

//# sourceMappingURL=satellite.js.map